import * as React from 'react';

export default class Content extends React.Component {
  render() {
    return (
        <div>
            {this.props.children}
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-react-wrapper/src/tabstrip/content.tsx